export default __webpack_public_path__ + "static/media/ct213-4.65e8e5f1.png";